import { render, staticRenderFns } from "./DockingDashboardProgress.vue?vue&type=template&id=b2d64d62&scoped=true"
import script from "./DockingDashboardProgress.vue?vue&type=script&lang=js"
export * from "./DockingDashboardProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d64d62",
  null
  
)

export default component.exports